import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import { urls } from '@/constants';

import ConsumeRedirectRoute from '@/components/Navigation/ConsumeRedirectRoute';

import PurchasedPackagesListPage from './PurchasedPackagesListPage';

const PurchasedPackages = () => (
  <Switch>
    <Route exact path={urls.purchasedPackages.list} component={PurchasedPackagesListPage} />

    <ConsumeRedirectRoute render={() => <Redirect to={urls.purchasedPackages.list} />} />
  </Switch>
);

export default PurchasedPackages;
